// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as $$String from "../../../../../../../../node_modules/rescript/lib/es6/string.js";
import * as Formality from "../../../../../../../../node_modules/re-formality/src/Formality.mjs";
import * as Formality__ReactUpdate from "../../../../../../../../node_modules/re-formality/src/Formality__ReactUpdate.mjs";
import * as CommonHelper$PorterinFeature from "../../../../core/helpers/CommonHelper.mjs";
import * as FareEstimateHelper$PorterinFeature from "../../../../core/helpers/FareEstimateHelper.mjs";

var validators_consent_for_callback = {
  strategy: /* OnFirstSuccessOrFirstBlur */3,
  validate: (function (param, metadata) {
      return FareEstimateHelper$PorterinFeature.isCallbackConsentMandatory(param.consent_for_callback, metadata.country);
    })
};

var validators_requirement = {
  strategy: /* OnFirstSuccess */2,
  validate: (function (param, metadata) {
      var requirement = param.requirement;
      if (requirement !== undefined) {
        return {
                TAG: /* Ok */0,
                _0: requirement
              };
      } else {
        return {
                TAG: /* Error */1,
                _0: metadata.error_msgs.requirement
              };
      }
    })
};

var validators_mobile = {
  strategy: /* OnFirstSuccessOrFirstBlur */3,
  validate: (function (param, metadata) {
      var mobile = param.mobile;
      if (mobile.length <= 0) {
        return {
                TAG: /* Error */1,
                _0: metadata.error_msgs.phone
              };
      }
      var _error = CommonHelper$PorterinFeature.validateNumber(mobile, metadata.country);
      if (_error.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: _error._0
              };
      } else {
        return {
                TAG: /* Error */1,
                _0: metadata.error_msgs.phone
              };
      }
    })
};

var validators_name = {
  strategy: /* OnFirstSuccessOrFirstBlur */3,
  validate: (function (param, metadata) {
      return CommonHelper$PorterinFeature.validateName($$String.trim(param.name), metadata.error_msgs.name);
    })
};

var validators_drop_address = {
  strategy: /* OnFirstSuccess */2,
  validate: (function (param, metadata) {
      var drop_address = param.drop_address;
      if (drop_address.landmark.length > 0 && drop_address.location.lat > 0.0 && drop_address.location.lat < 1000.0) {
        return {
                TAG: /* Ok */0,
                _0: drop_address
              };
      } else {
        return {
                TAG: /* Error */1,
                _0: metadata.error_msgs.drop
              };
      }
    })
};

var validators_pickup_address = {
  strategy: /* OnFirstSuccess */2,
  validate: (function (param, metadata) {
      var pickup_address = param.pickup_address;
      if (pickup_address.landmark.length > 0 && pickup_address.location.lat > 0.0 && pickup_address.location.lat < 1000.0) {
        return {
                TAG: /* Ok */0,
                _0: pickup_address
              };
      } else {
        return {
                TAG: /* Error */1,
                _0: metadata.error_msgs.pickup
              };
      }
    })
};

var validators = {
  consent_for_callback: validators_consent_for_callback,
  requirement: validators_requirement,
  mobile: validators_mobile,
  name: validators_name,
  drop_address: validators_drop_address,
  pickup_address: validators_pickup_address
};

function initialFieldsStatuses(_input) {
  return {
          consent_for_callback: /* Pristine */0,
          requirement: /* Pristine */0,
          mobile: /* Pristine */0,
          name: /* Pristine */0,
          drop_address: /* Pristine */0,
          pickup_address: /* Pristine */0
        };
}

function initialState(input) {
  return {
          input: input,
          fieldsStatuses: initialFieldsStatuses(input),
          collectionsStatuses: undefined,
          formStatus: /* Editing */0,
          submissionStatus: /* NeverSubmitted */0
        };
}

function validateForm(input, validators, fieldsStatuses, metadata) {
  var match = fieldsStatuses.consent_for_callback;
  var match_0 = match ? match._0 : Curry._2(validators.consent_for_callback.validate, input, metadata);
  var match$1 = fieldsStatuses.requirement;
  var match_0$1 = match$1 ? match$1._0 : Curry._2(validators.requirement.validate, input, metadata);
  var match$2 = fieldsStatuses.mobile;
  var match_0$2 = match$2 ? match$2._0 : Curry._2(validators.mobile.validate, input, metadata);
  var match$3 = fieldsStatuses.name;
  var match_0$3 = match$3 ? match$3._0 : Curry._2(validators.name.validate, input, metadata);
  var match$4 = fieldsStatuses.drop_address;
  var match_0$4 = match$4 ? match$4._0 : Curry._2(validators.drop_address.validate, input, metadata);
  var match$5 = fieldsStatuses.pickup_address;
  var match_0$5 = match$5 ? match$5._0 : Curry._2(validators.pickup_address.validate, input, metadata);
  var consent_for_callbackResult = match_0;
  var consent_for_callbackResult$1;
  if (consent_for_callbackResult.TAG === /* Ok */0) {
    var requirementResult = match_0$1;
    if (requirementResult.TAG === /* Ok */0) {
      var mobileResult = match_0$2;
      if (mobileResult.TAG === /* Ok */0) {
        var nameResult = match_0$3;
        if (nameResult.TAG === /* Ok */0) {
          var drop_addressResult = match_0$4;
          if (drop_addressResult.TAG === /* Ok */0) {
            var pickup_addressResult = match_0$5;
            if (pickup_addressResult.TAG === /* Ok */0) {
              return {
                      TAG: /* Valid */0,
                      output: {
                        pickup_address: pickup_addressResult._0,
                        drop_address: drop_addressResult._0,
                        name: nameResult._0,
                        mobile: mobileResult._0,
                        requirement: requirementResult._0,
                        consent_for_callback: consent_for_callbackResult._0
                      },
                      fieldsStatuses: {
                        consent_for_callback: /* Dirty */{
                          _0: consent_for_callbackResult,
                          _1: /* Shown */0
                        },
                        requirement: /* Dirty */{
                          _0: requirementResult,
                          _1: /* Shown */0
                        },
                        mobile: /* Dirty */{
                          _0: mobileResult,
                          _1: /* Shown */0
                        },
                        name: /* Dirty */{
                          _0: nameResult,
                          _1: /* Shown */0
                        },
                        drop_address: /* Dirty */{
                          _0: drop_addressResult,
                          _1: /* Shown */0
                        },
                        pickup_address: /* Dirty */{
                          _0: pickup_addressResult,
                          _1: /* Shown */0
                        }
                      },
                      collectionsStatuses: undefined
                    };
            }
            consent_for_callbackResult$1 = consent_for_callbackResult;
          } else {
            consent_for_callbackResult$1 = consent_for_callbackResult;
          }
        } else {
          consent_for_callbackResult$1 = consent_for_callbackResult;
        }
      } else {
        consent_for_callbackResult$1 = consent_for_callbackResult;
      }
    } else {
      consent_for_callbackResult$1 = consent_for_callbackResult;
    }
  } else {
    consent_for_callbackResult$1 = consent_for_callbackResult;
  }
  return {
          TAG: /* Invalid */1,
          fieldsStatuses: {
            consent_for_callback: /* Dirty */{
              _0: consent_for_callbackResult$1,
              _1: /* Shown */0
            },
            requirement: /* Dirty */{
              _0: match_0$1,
              _1: /* Shown */0
            },
            mobile: /* Dirty */{
              _0: match_0$2,
              _1: /* Shown */0
            },
            name: /* Dirty */{
              _0: match_0$3,
              _1: /* Shown */0
            },
            drop_address: /* Dirty */{
              _0: match_0$4,
              _1: /* Shown */0
            },
            pickup_address: /* Dirty */{
              _0: match_0$5,
              _1: /* Shown */0
            }
          },
          collectionsStatuses: undefined
        };
}

function useForm(initialInput, metadata, onSubmit) {
  var memoizedInitialState = React.useMemo((function () {
          return initialState(initialInput);
        }), [initialInput]);
  var match = Formality__ReactUpdate.useReducer(memoizedInitialState, (function (state, action) {
          if (typeof action === "number") {
            switch (action) {
              case /* BlurConsent_for_callbackField */0 :
                  var result = Formality.validateFieldOnBlurWithValidatorAndMetadata(state.input, metadata, state.fieldsStatuses.consent_for_callback, validators_consent_for_callback, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  consent_for_callback: status,
                                  requirement: init.requirement,
                                  mobile: init.mobile,
                                  name: init.name,
                                  drop_address: init.drop_address,
                                  pickup_address: init.pickup_address
                                };
                        }));
                  if (result !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurRequirementField */1 :
                  var result$1 = Formality.validateFieldOnBlurWithValidatorAndMetadata(state.input, metadata, state.fieldsStatuses.requirement, validators_requirement, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  consent_for_callback: init.consent_for_callback,
                                  requirement: status,
                                  mobile: init.mobile,
                                  name: init.name,
                                  drop_address: init.drop_address,
                                  pickup_address: init.pickup_address
                                };
                        }));
                  if (result$1 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$1,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurMobileField */2 :
                  var result$2 = Formality.validateFieldOnBlurWithValidatorAndMetadata(state.input, metadata, state.fieldsStatuses.mobile, validators_mobile, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  consent_for_callback: init.consent_for_callback,
                                  requirement: init.requirement,
                                  mobile: status,
                                  name: init.name,
                                  drop_address: init.drop_address,
                                  pickup_address: init.pickup_address
                                };
                        }));
                  if (result$2 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$2,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurNameField */3 :
                  var result$3 = Formality.validateFieldOnBlurWithValidatorAndMetadata(state.input, metadata, state.fieldsStatuses.name, validators_name, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  consent_for_callback: init.consent_for_callback,
                                  requirement: init.requirement,
                                  mobile: init.mobile,
                                  name: status,
                                  drop_address: init.drop_address,
                                  pickup_address: init.pickup_address
                                };
                        }));
                  if (result$3 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$3,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurDrop_addressField */4 :
                  var result$4 = Formality.validateFieldOnBlurWithValidatorAndMetadata(state.input, metadata, state.fieldsStatuses.drop_address, validators_drop_address, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  consent_for_callback: init.consent_for_callback,
                                  requirement: init.requirement,
                                  mobile: init.mobile,
                                  name: init.name,
                                  drop_address: status,
                                  pickup_address: init.pickup_address
                                };
                        }));
                  if (result$4 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$4,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurPickup_addressField */5 :
                  var result$5 = Formality.validateFieldOnBlurWithValidatorAndMetadata(state.input, metadata, state.fieldsStatuses.pickup_address, validators_pickup_address, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  consent_for_callback: init.consent_for_callback,
                                  requirement: init.requirement,
                                  mobile: init.mobile,
                                  name: init.name,
                                  drop_address: init.drop_address,
                                  pickup_address: status
                                };
                        }));
                  if (result$5 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$5,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* Submit */6 :
                  var match = state.formStatus;
                  if (typeof match !== "number" && match.TAG === /* Submitting */0) {
                    return /* NoUpdate */0;
                  }
                  var match$1 = validateForm(state.input, validators, state.fieldsStatuses, metadata);
                  if (match$1.TAG !== /* Valid */0) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: match$1.fieldsStatuses,
                              collectionsStatuses: match$1.collectionsStatuses,
                              formStatus: /* Editing */0,
                              submissionStatus: /* AttemptedToSubmit */1
                            }
                          };
                  }
                  var output = match$1.output;
                  var error = state.formStatus;
                  var tmp;
                  tmp = typeof error === "number" || error.TAG !== /* SubmissionFailed */1 ? undefined : error._0;
                  return {
                          TAG: /* UpdateWithSideEffects */1,
                          _0: {
                            input: state.input,
                            fieldsStatuses: match$1.fieldsStatuses,
                            collectionsStatuses: match$1.collectionsStatuses,
                            formStatus: {
                              TAG: /* Submitting */0,
                              _0: tmp
                            },
                            submissionStatus: /* AttemptedToSubmit */1
                          },
                          _1: (function (param) {
                              var dispatch = param.dispatch;
                              Curry._2(onSubmit, output, {
                                    notifyOnSuccess: (function (input) {
                                        Curry._1(dispatch, {
                                              TAG: /* SetSubmittedStatus */6,
                                              _0: input
                                            });
                                      }),
                                    notifyOnFailure: (function (error) {
                                        Curry._1(dispatch, {
                                              TAG: /* SetSubmissionFailedStatus */7,
                                              _0: error
                                            });
                                      }),
                                    reset: (function (param) {
                                        Curry._1(dispatch, /* Reset */9);
                                      }),
                                    dismissSubmissionResult: (function (param) {
                                        Curry._1(dispatch, /* DismissSubmissionResult */8);
                                      })
                                  });
                            })
                        };
                  break;
              case /* DismissSubmissionError */7 :
                  var match$2 = state.formStatus;
                  if (typeof match$2 === "number" || match$2.TAG !== /* SubmissionFailed */1) {
                    return /* NoUpdate */0;
                  } else {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: /* Editing */0,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
              case /* DismissSubmissionResult */8 :
                  var match$3 = state.formStatus;
                  if (typeof match$3 === "number") {
                    if (match$3 === /* Editing */0) {
                      return /* NoUpdate */0;
                    }
                    
                  } else if (match$3.TAG === /* Submitting */0) {
                    return /* NoUpdate */0;
                  }
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: state.input,
                            fieldsStatuses: state.fieldsStatuses,
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: /* Editing */0,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* Reset */9 :
                  return {
                          TAG: /* Update */0,
                          _0: initialState(initialInput)
                        };
              
            }
          } else {
            switch (action.TAG | 0) {
              case /* UpdateConsent_for_callbackField */0 :
                  var nextInput = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidatorAndMetadata(nextInput, metadata, state.fieldsStatuses.consent_for_callback, state.submissionStatus, validators_consent_for_callback, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            consent_for_callback: status,
                                            requirement: init.requirement,
                                            mobile: init.mobile,
                                            name: init.name,
                                            drop_address: init.drop_address,
                                            pickup_address: init.pickup_address
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateRequirementField */1 :
                  var nextInput$1 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$1,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidatorAndMetadata(nextInput$1, metadata, state.fieldsStatuses.requirement, state.submissionStatus, validators_requirement, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            consent_for_callback: init.consent_for_callback,
                                            requirement: status,
                                            mobile: init.mobile,
                                            name: init.name,
                                            drop_address: init.drop_address,
                                            pickup_address: init.pickup_address
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateMobileField */2 :
                  var nextInput$2 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$2,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidatorAndMetadata(nextInput$2, metadata, state.fieldsStatuses.mobile, state.submissionStatus, validators_mobile, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            consent_for_callback: init.consent_for_callback,
                                            requirement: init.requirement,
                                            mobile: status,
                                            name: init.name,
                                            drop_address: init.drop_address,
                                            pickup_address: init.pickup_address
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateNameField */3 :
                  var nextInput$3 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$3,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidatorAndMetadata(nextInput$3, metadata, state.fieldsStatuses.name, state.submissionStatus, validators_name, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            consent_for_callback: init.consent_for_callback,
                                            requirement: init.requirement,
                                            mobile: init.mobile,
                                            name: status,
                                            drop_address: init.drop_address,
                                            pickup_address: init.pickup_address
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateDrop_addressField */4 :
                  var nextInput$4 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$4,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidatorAndMetadata(nextInput$4, metadata, state.fieldsStatuses.drop_address, state.submissionStatus, validators_drop_address, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            consent_for_callback: init.consent_for_callback,
                                            requirement: init.requirement,
                                            mobile: init.mobile,
                                            name: init.name,
                                            drop_address: status,
                                            pickup_address: init.pickup_address
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdatePickup_addressField */5 :
                  var nextInput$5 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$5,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidatorAndMetadata(nextInput$5, metadata, state.fieldsStatuses.pickup_address, state.submissionStatus, validators_pickup_address, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            consent_for_callback: init.consent_for_callback,
                                            requirement: init.requirement,
                                            mobile: init.mobile,
                                            name: init.name,
                                            drop_address: init.drop_address,
                                            pickup_address: status
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* SetSubmittedStatus */6 :
                  var input = action._0;
                  if (input !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: input,
                              fieldsStatuses: initialFieldsStatuses(input),
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: /* Submitted */1,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: initialFieldsStatuses(state.input),
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: /* Submitted */1,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
              case /* SetSubmissionFailedStatus */7 :
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: state.input,
                            fieldsStatuses: state.fieldsStatuses,
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: {
                              TAG: /* SubmissionFailed */1,
                              _0: action._0
                            },
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* MapSubmissionError */8 :
                  var map = action._0;
                  var error$1 = state.formStatus;
                  if (typeof error$1 === "number") {
                    return /* NoUpdate */0;
                  }
                  if (error$1.TAG !== /* Submitting */0) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: {
                                TAG: /* SubmissionFailed */1,
                                _0: Curry._1(map, error$1._0)
                              },
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
                  var error$2 = error$1._0;
                  if (error$2 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: {
                                TAG: /* Submitting */0,
                                _0: Curry._1(map, error$2)
                              },
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              
            }
          }
        }));
  var dispatch = match[1];
  var state = match[0];
  var match$1 = state.formStatus;
  var tmp;
  tmp = typeof match$1 === "number" || match$1.TAG !== /* Submitting */0 ? false : true;
  return {
          updateConsent_for_callback: (function (nextInputFn, nextValue) {
              Curry._1(dispatch, {
                    TAG: /* UpdateConsent_for_callbackField */0,
                    _0: (function (__x) {
                        return Curry._2(nextInputFn, __x, nextValue);
                      })
                  });
            }),
          updateRequirement: (function (nextInputFn, nextValue) {
              Curry._1(dispatch, {
                    TAG: /* UpdateRequirementField */1,
                    _0: (function (__x) {
                        return Curry._2(nextInputFn, __x, nextValue);
                      })
                  });
            }),
          updateMobile: (function (nextInputFn, nextValue) {
              Curry._1(dispatch, {
                    TAG: /* UpdateMobileField */2,
                    _0: (function (__x) {
                        return Curry._2(nextInputFn, __x, nextValue);
                      })
                  });
            }),
          updateName: (function (nextInputFn, nextValue) {
              Curry._1(dispatch, {
                    TAG: /* UpdateNameField */3,
                    _0: (function (__x) {
                        return Curry._2(nextInputFn, __x, nextValue);
                      })
                  });
            }),
          updateDrop_address: (function (nextInputFn, nextValue) {
              Curry._1(dispatch, {
                    TAG: /* UpdateDrop_addressField */4,
                    _0: (function (__x) {
                        return Curry._2(nextInputFn, __x, nextValue);
                      })
                  });
            }),
          updatePickup_address: (function (nextInputFn, nextValue) {
              Curry._1(dispatch, {
                    TAG: /* UpdatePickup_addressField */5,
                    _0: (function (__x) {
                        return Curry._2(nextInputFn, __x, nextValue);
                      })
                  });
            }),
          blurConsent_for_callback: (function (param) {
              Curry._1(dispatch, /* BlurConsent_for_callbackField */0);
            }),
          blurRequirement: (function (param) {
              Curry._1(dispatch, /* BlurRequirementField */1);
            }),
          blurMobile: (function (param) {
              Curry._1(dispatch, /* BlurMobileField */2);
            }),
          blurName: (function (param) {
              Curry._1(dispatch, /* BlurNameField */3);
            }),
          blurDrop_address: (function (param) {
              Curry._1(dispatch, /* BlurDrop_addressField */4);
            }),
          blurPickup_address: (function (param) {
              Curry._1(dispatch, /* BlurPickup_addressField */5);
            }),
          consent_for_callbackResult: Formality.exposeFieldResult(state.fieldsStatuses.consent_for_callback),
          requirementResult: Formality.exposeFieldResult(state.fieldsStatuses.requirement),
          mobileResult: Formality.exposeFieldResult(state.fieldsStatuses.mobile),
          nameResult: Formality.exposeFieldResult(state.fieldsStatuses.name),
          drop_addressResult: Formality.exposeFieldResult(state.fieldsStatuses.drop_address),
          pickup_addressResult: Formality.exposeFieldResult(state.fieldsStatuses.pickup_address),
          input: state.input,
          status: state.formStatus,
          dirty: (function (param) {
              var match = state.fieldsStatuses;
              if (match.consent_for_callback || match.requirement || match.mobile || match.name || match.drop_address || match.pickup_address) {
                return true;
              } else {
                return false;
              }
            }),
          valid: (function (param) {
              var match = validateForm(state.input, validators, state.fieldsStatuses, metadata);
              if (match.TAG === /* Valid */0) {
                return true;
              } else {
                return false;
              }
            }),
          submitting: tmp,
          submit: (function (param) {
              Curry._1(dispatch, /* Submit */6);
            }),
          dismissSubmissionError: (function (param) {
              Curry._1(dispatch, /* DismissSubmissionError */7);
            }),
          dismissSubmissionResult: (function (param) {
              Curry._1(dispatch, /* DismissSubmissionResult */8);
            }),
          mapSubmissionError: (function (map) {
              Curry._1(dispatch, {
                    TAG: /* MapSubmissionError */8,
                    _0: map
                  });
            }),
          reset: (function (param) {
              Curry._1(dispatch, /* Reset */9);
            })
        };
}

var Form = {
  validators: validators,
  initialFieldsStatuses: initialFieldsStatuses,
  initialCollectionsStatuses: undefined,
  initialState: initialState,
  validateForm: validateForm,
  useForm: useForm
};

export {
  Form ,
}
/* react Not a pure module */
